import { getCsrfToken } from '../auth/authApi'
import type { EngineeringSnapshot } from './types'
import { getDeletionAvailability } from '../../shared/deletion/deletionApi'
import { apiFetch } from '../../shared/http/apiFetch'

const baseUrl = '/api/v1/engineering'

export async function getEngineering(options?:{section?:string;query?:string;status?:string;page?:number;pageSize?:number;detailKey?:string}, signal?: AbortSignal): Promise<EngineeringSnapshot> {
  const parameters = new URLSearchParams()
  if (options) Object.entries(options).forEach(([key, value]) => {
    if (value !== undefined && value !== '') parameters.set(key, String(value))
  })
  const response = await apiFetch(`${baseUrl}${parameters.size ? `?${parameters}` : ''}`, { credentials: 'include', signal })
  if (!response.ok) {
    const payload = await response.json().catch(() => null) as { code?: string } | null
    throw new Error(payload?.code ?? 'engineering.loadError')
  }
  return response.json() as Promise<EngineeringSnapshot>
}

export async function engineeringCommand(
  path: string,
  method: 'POST' | 'PUT' | 'DELETE',
  body?: unknown,
) {
  const response = await apiFetch(`${baseUrl}${path}`, {
    method,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': await getCsrfToken(),
    },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  })
  const payload = await response.json().catch(() => null) as { code?: string } | null
  if (!response.ok) throw new Error(payload?.code ?? 'engineering.actionError')
  return payload?.code ?? 'engineering.saved'
}

export const getEngineeringDeletionAvailability = (path: string) =>
  getDeletionAvailability(`${baseUrl}${path}`)
